import IcraaPageConfigProvider from './IcraaPageConfigProvider';

export default IcraaPageConfigProvider;
